let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8V6dt")).then(() => parcelRequire('4C3cU'));